const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/plans-corporate-checklist-item', {
  title: 'Plans Corporate Checklist Item',
  description: 'Item de plans corporate',
  icon: 'yes-alt',
  category: 'design',
  parent: ['app/plans-corporate-item'],
  attributes,
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
